import Phaser from 'phaser';
import { Hell1CombatScene, TutorialScene } from './scenes/CombatArenaScene';
import { Hell1EntryScene } from './scenes/Hell1EntryScene';
import { HubScene } from './scenes/HubScene';
import { StatPickScene } from './scenes/StatPickScene';

const GAME_WIDTH = 960;
const GAME_HEIGHT = 540;

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'app',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#12121c',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [TutorialScene, Hell1CombatScene, Hell1EntryScene, HubScene, StatPickScene],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  pixelArt: false,
  roundPixels: true,
});
